// extracted by mini-css-extract-plugin
export default {"icon-button":"IconButton_icon-button__tkTEV App_--rubber-fx__yYj6p"};